import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'

export default {
  methods: {
    showEdit (event) {
      const { data } = event || {}
      const { id } = data || {}
      const query = {
        groupName: data?.name || ''
      }

      if (!id) {
        return
      }

      this.$router.push({
        name: 'FleetGroupView',
        params: {
          id
        },
        query
      }).then()
    },

    onGroupActivation (event) {
      const { deactivated_at: deactivatedAt, id, name } = event?.data || {}
      if (!id) {
        return
      }
      const title = !deactivatedAt ? this.$t('fleet/group.deactivate') : this.$t('fleet/group.activate')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', !deactivatedAt ? this.$t('base.deactivate') : this.$t('base.activate'))
      this.$set(this.informationDialogConfig, 'message', !deactivatedAt ? this.$t('fleet/group.confirm_deactivation') : this.$t('fleet/group.confirm_activation'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.groupActivation(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async groupActivation (event) {
      try {
        const { id, deactivated_at: deactivatedAt } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.groups || {}
        await api('fleet').patch(`groups/${id}/${deactivatedAt ? 'activate' : 'deactivate'}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onGroupDelete (event) {
      const { id, name } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('fleet/group.delete')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.groupDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async groupDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.groups || {}

        await api('fleet').delete(`groups/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
